import I18n from 'I18n';
export const getEditorDisabledMessage = ({
  hasConversationsInteract,
  hasThreadBeenBatchUpdated,
  isAdminNotMemberOfInbox
}) => {
  if (hasThreadBeenBatchUpdated) return I18n.text('conversations-inbox-ui.chat-communicator.batchUpdated');else if (!hasConversationsInteract) return I18n.text('conversations-inbox-ui.chat-communicator.readOnly');else if (isAdminNotMemberOfInbox) return I18n.text('conversations-inbox-ui.chat-communicator.notInboxMember');
  return null;
};